// The registration order follows showModal(), which can differ from portal DOM
// order when parent and child dialogs open in the same render.
const dialogs: HTMLDialogElement[] = [];
const listeners = new Set<() => void>();

export const getActiveModal = (): HTMLDialogElement | null => dialogs[dialogs.length - 1] ?? null;
export const subscribeToModalLayer = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export const registerModalLayer = (dialog: HTMLDialogElement): (() => void) => {
  dialogs.push(dialog);
  listeners.forEach((listener) => listener());
  return () => {
    const index = dialogs.indexOf(dialog);
    if (index < 0) return;
    dialogs.splice(index, 1);
    listeners.forEach((listener) => listener());
  };
};
